// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__Rj5GZ","item":"styles_item__LEG2L","buttonsBlock":"styles_buttonsBlock__2KQ6F"};